
import type { GradeData } from "../models";

export default {
  props: ["addGrade"],
  data() {
    return {
      formGrade: {},
    }
  },
  methods: {
    addgradeFormSubmit(e: Event) {
      e.preventDefault();
      const self: any = this;
      self.addGrade({ ...self.formGrade } as GradeData);
      self.formGrade = {};
    },
  },
};
